import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaLink, Heading, Lead, Section } from './ui';
import { whatsappUrl } from '../../data/links';
import { closingChecklist } from '../../data/vcars';
export function FinalCtaSection() {
  return <Section id="contacto" className="bg-[#0c0e12]" data-id="element-24" data-mp="v4qim1zbq2k5">
      <div className="grid gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:gap-16" data-id="element-25" data-mp="z850ky6tot08">
        <div data-id="element-26" data-mp="14783od38sp5k">
          <Heading className="text-white" data-id="element-27" data-mp="147hsvyggqsa7">
            Tu próximo auto puede estar más cerca de lo que pensás
          </Heading>
          <Lead className="mt-4 text-white/60" data-id="element-28" data-mp="19487ehcmdfti">
            Escribinos por WhatsApp y contanos qué estás buscando. En VCARS te
            ayudamos a encontrar una opción acorde a tu presupuesto.
          </Lead>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-29" data-mp="1ixp3js08b70c">
            <CtaLink href={whatsappUrl('Hola VCARS, quiero asesoramiento para comprar mi próximo auto.')} label="Hablar con VCARS por WhatsApp" data-id="element-30" data-mp="1myskyixxdb3o" />
            <CtaLink href={whatsappUrl('Hola VCARS, quiero que me contacten.')} label="Quiero que me contacten" variant="ghost" withIcon={false} data-id="element-31" data-mp="1u23gqjfvukj6" />
          </div>
        </div>

        <div className="bg-[#12141a] p-6 sm:p-8" data-id="element-32" data-mp="1g584yj88yezf">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[#7f9bff]" data-id="element-33" data-mp="1g6j94k5ltor2">
            Contanos esto
          </p>
          <ul className="mt-5 space-y-3" data-id="element-34" data-mp="28tce5eq11a6v">
            {closingChecklist.map(item => <li key={item} className="flex items-center gap-3" data-id="element-35" data-mp="242dtk2y09pxt">
                <CheckIcon className="h-5 w-5 shrink-0 text-[#5b83ff]" strokeWidth={3} data-id="element-36" data-mp="240j9equk61us" />
                <span className="text-base text-white/85 sm:text-lg" data-id="element-37" data-mp="2wietuh13osyq">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}